import { DELETE_FOUNDERS_ERROR, DELETE_FOUNDERS_START, DELETE_FOUNDERS_SUCCESS } from '../../types';

export default function delete_founders(state, action) {
  switch (action.type) {
    case DELETE_FOUNDERS_START:
      return { ...state };
    case DELETE_FOUNDERS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case DELETE_FOUNDERS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}